
import SimpleMDE from "simplemde"

export default function addMarkdown() {

    var htmlTips = '<a href="#" class="close-popup-tips" id="closePopUpMarkdownGuide"></a>' +
                    '<h3>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuide'] + '</h3>' +
                    '<div id="markdown-guide">' +
                        '<div class="col">' +
                            '<h4>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideEmphasis'] + '</h4>' +
                            '<pre>**<strong>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideEmphasisBold'] + '</strong>**</pre>' +
                            '<pre>*<em>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideEmphasisItalics'] + '</em>*</pre>' +
                            '</pre>' +
                        '</div>' +
                        '<div class="col">' +
                            '<h4>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideHeaders'] + '</h4>' +
                            '<pre># ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideHeadersBig'] + '</pre>' +
                            '<pre>## ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideHeadersMedium'] + '</pre>' +
                            '<pre>### ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideHeadersSmall'] + '</pre>' +
                            '<pre>#### ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideHeadersTiny'] + '</pre>' +
                            '</pre>' +
                        '</div>' +
                        '<div class="col">' +
                            '<h4>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideLists'] + '</h4>' +
                            '<pre>* ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsGeneric'] + '</pre>' +
                            '<pre>* ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsGeneric'] + '</pre>' +
                            '<pre>* ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsGeneric'] + '</pre>' +

                            '<pre>1. ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsNumbered'] + '</pre>' +
                            '<pre>2. ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsNumbered'] + '</pre>' +
                            '<pre>3. ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideListsNumbered'] + '</pre>' +
                        '</div>' +
                        '<div class="col">' +
                            '<h4>' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideQuotes'] + '</h4>' +
                            '<pre>&gt; ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideQuotes1'] + '\n' +
                            '&gt; ' + JSON.parse(document.querySelector('#json_translations').innerHTML)['popUpMarkdownGuideQuotes2'] + '</pre>' +
                        '</div>' +
                    '</div>';
    var mdeEl = document.querySelectorAll('.markdown');
    [].forEach.call(mdeEl, function(el) {
        var elMDE = el.querySelector('textarea');
        elMDE.simplemde = new SimpleMDE({
            element: elMDE,
            forceSync: true,
            hideIcons: ["image", "guide", "link"],
            status: false,
            spellChecker: false,
            insertTexts: {
                image: ['']
            },
            toolbar: [
                {
                    name: "bold",
                    action: SimpleMDE.toggleBold,
                    className: "fa fa-bold",
                    title: "Bold",
                },
                {
                    name: "italic",
                    action: SimpleMDE.toggleItalic,
                    className: "fa fa-italic",
                    title: "Italic",
                },
                {
                    name: "heading",
                    action: SimpleMDE.toggleHeadingSmaller,
                    className: "fa fa-header",
                    title: "Heading",
                },
                "|",
                {
                    name: "blockquote",
                    action: SimpleMDE.toggleBlockquote,
                    className: "fa fa-quote-left",
                    title: "Blockquote",
                },
                {
                    name: "unorderedlist",
                    action: SimpleMDE.toggleUnorderedList,
                    className: "fa fa-list-ul",
                    title: "Unordered List",
                },
                {
                    name: "orderedlist",
                    action: SimpleMDE.toggleOrderedList,
                    className: "fa fa-list-ol",
                    title: "Ordered List",
                },
                "|",
                {
                    name: "preview",
                    action: SimpleMDE.togglePreview,
                    className: "fa fa-eye no-disable",
                    title: "Toggle Preview",
                },
                "|",
                {
                    name: "side-by-side",
                    action: SimpleMDE.toggleSideBySide,
                    className: "fa fa-columns no-disable no-mobile",
                    title: "Toggle Side by Side",
                },
                "|",
                {
                    name: "fullscreen",
                    action: SimpleMDE.toggleFullScreen,
                    className: "fa fa-arrows-alt no-disable no-mobile",
                    title: "Toggle Fullscreen",
                },
                "|",
                {
                    name :  "tips" ,
                        action :  function  tipsFunction ( editor ) {
                        var elPopupTips = document.querySelector('#popup-tips');
                        if(elPopupTips == null) {
                            var popUpMarkdown = document.createElement('div');
                            popUpMarkdown.setAttribute('id', 'popup-tips')
                            popUpMarkdown.innerHTML = htmlTips
                            document.body.appendChild(popUpMarkdown);
                        }

                        var closePopUpMarkdownGuide = document.getElementById('closePopUpMarkdownGuide');
                        closePopUpMarkdownGuide.onclick = function(e) {
                            e.preventDefault();
                            var rPopupTips = document.getElementById('popup-tips');
                                rPopupTips.remove();
                        }
                    },
                    className :  "fa fa-question-circle" ,
                    title :  "Markdown Guide" ,
                }],
        });

        elMDE.simplemde.codemirror.on("change", function(){
            var event = document.createEvent('HTMLEvents');
            event.initEvent('blur', true, false);
            elMDE.dispatchEvent(event);
        });
    });
}






